export function getView(width) {
  let newView = 'MobileView';
  if (width > 1220) {
    newView = 'DesktopView';
  } else if (width > 767) {
    newView = 'TabView';
  }
  return newView;
}
const actions = {
  COLLPSE_CHANGE: 'COLLPSE_CHANGE',
  COLLPSE_OPEN_DRAWER: 'COLLPSE_OPEN_DRAWER',
  CHANGE_OPEN_KEYS: 'CHANGE_OPEN_KEYS',
  TOGGLE_ALL: 'TOGGLE_ALL',
  UPDATE_REDUX:'UPDATE_REDUX',
  CHANGE_CURRENT: 'CHANGE_CURRENT',
  SET_PREMIUM_STATUS: 'SET_PREMIUM_STATUS',
  UPDATE_SIDEBAR: 'UPDATE_SIDEBAR',
  // SET_NOTIFICATION:'SET_NOTIFICATION',
  // UNSET_NOTIFICATION:'UNSET_NOTIFICATION',

  // Actions Functions
  updateSidebar: () => ({
    type: actions.UPDATE_SIDEBAR
  }),
  toggleCollapsed: () => ({
    type: actions.COLLPSE_CHANGE
  }),
  updateRedux: (payload) =>({
    type:actions.UPDATE_REDUX,
    payload
  }),
  toggleAll: (width, height) => {
    const view = getView(width);
    const collapsed = view !== 'DesktopView';
    return {
      type: actions.TOGGLE_ALL,
      collapsed,
      view,
      height
    };
  },
  toggleOpenDrawer: () => ({
    type: actions.COLLPSE_OPEN_DRAWER
  }),
  changeOpenKeys: openKeys => ({
    type: actions.CHANGE_OPEN_KEYS,
    openKeys
  }),
  changeCurrent: current => ({
    type: actions.CHANGE_CURRENT,
    current
  }),
  // notification: (notificationType,message,description) =>({
  //   type:actions.SET_NOTIFICATION,
  //   notificationType,
  //   message,
  //   description
  // }),
  // unsetNotification:(value=null)=>({
  //   type:actions.UNSET_NOTIFICATION,
  //   value
  // }),
  // setPayers: (payload)=>({
  //   type:actions.SET_PAYERS,
  //   payload
  // }),

};
export default actions;
